"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.previewTypeaheadResponse = exports.TYPEAHEAD_DEBOUNCE_DELAY = exports.MIN_CHARACTER_COUNT = exports.SUGGESTION_CLICKED = exports.DEFAULT_TYPEAHEAD_DISPLAY_TEXT = exports.SEARCH_URL = exports.TYPEAHEAD_V8_URL = exports.TYPEAHEAD_URL = exports.CONFIG_URL = void 0;
exports.CONFIG_URL = '/api/v2/search_widget';
// v9 routes in PMC are passthrough, so the rest of the URL is built in buildTypeaheadURL
exports.TYPEAHEAD_URL = '/api/searchservice-v9';
exports.TYPEAHEAD_V8_URL = '/autocomplete';
exports.SEARCH_URL = '/search';
// TODO validate all of these
exports.DEFAULT_TYPEAHEAD_DISPLAY_TEXT = {
    // v8 categories
    clinical_combined: 'Conditions and Treatments',
    clinical_experience: 'Conditions and Treatments',
    name: 'Providers',
    network_affiliation: 'Networks',
    practice_group: 'Practices',
    practice_location: 'Locations',
    primary_care: 'Primary Care Providers',
    primary_care_condition: 'Conditions and Treatments',
    provider_name: 'Providers',
    specialty: 'Specialties',
    specialty_strict: 'Specialties',
    specialty_synonym: 'Specialties',
    // v9 categories (some haven't changed, so might be in the v8 ones above)
    clinical_keywords: 'Conditions and Treatments',
    conditions_symptoms: 'Conditions and Symptoms',
    location_name: 'Locations',
    marketable_locations: 'Locations',
    marketable_location_type: 'Location Types',
    marketable_location_services: 'Services',
    specialties: 'Specialties',
    treatments_procedures: 'Treatments and Procedures'
};
exports.SUGGESTION_CLICKED = 'user_action.search_widget.suggestion_click';
// the minimum characters we need before we send requests for suggestions
exports.MIN_CHARACTER_COUNT = 2;
// the time we wait before we send requests for suggestions (after the user stops typing)
exports.TYPEAHEAD_DEBOUNCE_DELAY = 500;
exports.previewTypeaheadResponse = {
    clinical_keywords: [
        {
            highlight: '<em>heart</em>burn',
            name: 'heartburn',
            score: 12.736508,
            synonym: 'gastroesophageal reflux disease',
            type: 'term',
            uuid: 'T00019450'
        },
        {
            highlight: '<em>heart</em>land virus',
            name: 'heartland virus',
            score: 12.646098,
            synonym: null,
            type: 'concept',
            uuid: 'C3674298'
        },
        {
            highlight: '<em>heart</em> health',
            name: 'heart health',
            score: 12.646098,
            synonym: null,
            type: 'concept',
            uuid: 'C3663857'
        },
        {
            highlight: 'irregular <em>heart</em>beat with exertion',
            name: 'irregular heartbeat with exertion',
            score: 12.556961,
            synonym: 'exercise induced arrhythmia',
            type: 'term',
            uuid: 'T00042529'
        },
        {
            highlight: 'fb in the <em>heart</em>',
            name: 'fb in the heart',
            score: 8.678695,
            synonym: 'foreign body (intracardiac)',
            type: 'term',
            uuid: 'T00063042'
        }
    ],
    provider_name: [
        {
            highlight: 'Broadway Health CT Scan South Shore',
            id: 1889830,
            name: 'Broadway Health CT Scan South Shore',
            score: 0.8
        },
        {
            highlight: 'Broadway Health Electrocardiogram (EKG)',
            id: 1922834,
            name: 'Broadway Health Electrocardiogram (EKG)',
            score: 0.8
        },
        {
            highlight: 'Broadway Health Blood Donation',
            id: 1490537,
            name: 'Broadway Health Blood Donation',
            score: 0.8
        },
        {
            highlight: 'Broadway Health X-Ray',
            id: 1922837,
            name: 'Broadway Health X-Ray',
            score: 0.8
        },
        {
            highlight: 'Broadway Health Physical Therapy Center',
            id: 1922141,
            name: 'Broadway Health Physical Therapy Center',
            score: 0.8
        }
    ],
    specialties: [
        {
            highlight: '<em>Heart</em> Failure and Transplantation Cardiology',
            name: 'Heart Failure and Transplantation Cardiology',
            score: 32.094482,
            synonym: null,
            type: 'specialty',
            uuid: 'E0000018'
        },
        {
            highlight: '<em>Heart</em> Dr',
            name: 'Heart Dr',
            score: 8.740741,
            synonym: 'Cardiology',
            type: 'alias',
            uuid: 'A0010418'
        },
        {
            highlight: '<em>Heart</em> Failure',
            name: 'Heart Failure',
            score: 8.678695,
            synonym: null,
            type: 'specialty',
            uuid: 'E0000859'
        },
        {
            highlight: 'Congenital <em>Heart</em> Disease',
            name: 'Congenital Heart Disease',
            score: 8.617522,
            synonym: 'Congenital Cardiac Disease',
            type: 'alias',
            uuid: 'A0009146'
        },
        {
            highlight: 'Pediatric <em>Heart</em> Doctor',
            name: 'Pediatric Heart Doctor',
            score: 8.617522,
            synonym: 'Pediatric Cardiology',
            type: 'alias',
            uuid: 'A0009207'
        }
    ]
};
//# sourceMappingURL=constants.js.map